(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire4a54"];
var parcelRegister = parcelRequire.register;
parcelRegister("9vwa5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $6ebff4f664ef2e25$export$2e2bcd8739ae039; });
class $6ebff4f664ef2e25$export$2e2bcd8739ae039 {
    constructor(element){
        this.element = element;
        this.toggleButton = this.element.querySelector('.-menu_toggle');
        this.navContent = this.element.querySelector('.-content');
        this.mobileBreakpoint = 1024;
        this.isMobileView = window.innerWidth < this.mobileBreakpoint;
        this.isExpanded = false;
        // Ensure the navigation content has an ID for aria-controls reference
        if (!this.navContent.id) this.navContent.id = 'nav-content';
    }
    init() {
        //console.log('Navigation observer initialized');
        this.toggleButton.addEventListener('click', this.handleToggle.bind(this));
        window.addEventListener('resize', this.handleResize.bind(this));
        // Set initial ARIA attributes
        this.toggleButton.setAttribute('aria-expanded', 'false');
        this.toggleButton.setAttribute('aria-controls', this.navContent.id);
        this.navContent.setAttribute('aria-hidden', 'true');
        // Initialize based on current window size
        this.updateView();
    }
    handleToggle() {
        this.isExpanded = !this.isExpanded;
        if (this.isExpanded) {
            this.navContent.classList.remove('--hidden');
            this.navContent.classList.add('--visible');
            this.toggleButton.classList.add('--expanded');
            // Update ARIA attributes
            this.toggleButton.setAttribute('aria-expanded', 'true');
            this.navContent.setAttribute('aria-hidden', 'false');
        } else {
            this.navContent.classList.remove('--visible');
            this.navContent.classList.add('--hidden');
            this.toggleButton.classList.remove('--expanded');
            // Update ARIA attributes
            this.toggleButton.setAttribute('aria-expanded', 'false');
            this.navContent.setAttribute('aria-hidden', 'true');
        }
    }
    handleResize() {
        const currentWidth = window.innerWidth;
        const wasMobileView = this.isMobileView;
        this.isMobileView = currentWidth < this.mobileBreakpoint;
        if (this.isMobileView !== wasMobileView) this.updateView();
    }
    updateView() {
        if (this.isMobileView) {
            this.navContent.classList.add('--hidden');
            this.toggleButton.classList.remove('--expanded');
            this.isExpanded = false;
            // Update ARIA attributes
            this.toggleButton.setAttribute('aria-expanded', 'false');
            this.navContent.setAttribute('aria-hidden', 'true');
        } else {
            this.navContent.classList.remove('--hidden');
            this.navContent.classList.remove('--visible');
            this.toggleButton.classList.remove('--expanded');
            this.isExpanded = false;
            // Remove ARIA attributes for desktop view
            this.toggleButton.removeAttribute('aria-expanded');
            this.navContent.removeAttribute('aria-hidden');
        }
    }
    destroy() {
        console.log('Navigation observer destroyed');
        this.toggleButton.removeEventListener('click', this.handleToggle.bind(this));
        window.removeEventListener('resize', this.handleResize.bind(this));
    }
}

});

})();
//# sourceMappingURL=Navigation.a173a3cd.js.map
